import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import globalEn from './locales/en/translation.json';
import globalEs from './locales/es/translation.json';
import globalFr from './locales/fr/translation.json';

const resources = {
  en: { translation: globalEn },
  es: { translation: globalEs },
  fr: { translation: globalFr },
};

i18n.use(initReactI18next).init({
  resources,
  ns: ['translation'],
  defaultNS: 'translation',
  lng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;


